<template>
    <div id="fitbaseWidgetContainer">
        <fitbase-widget
            theme="light"
            embedded-type="lk"
            :domain="this.$store.getters.systemUrl">
        </fitbase-widget>
    </div>
</template>

<script>
    export default {
        mounted() {
            let widgetScript = document.createElement('script')
            widgetScript.setAttribute('src', this.$store.getters.systemUrl + 'vue-resources/schedule-widget/dist/js/app.js')
            document.head.appendChild(widgetScript)
        },
    }
</script>
